import vendors from '../routes/vendors.json'

export const getVendors = () =>
  vendors.map((vendor) => ({
    name: vendor,
    icon: `/vendorPages/${vendor}/logo.svg`,
    url: `/${vendor}`,
  }))
